import type { UseAsyncCollectionResT } from '@dr.pogodin/react-global-state';
import { time } from '@dr.pogodin/react-utils';

import { getExperience } from 'services/experience';

import { type ExperienceT, useAsyncCollection } from 'utils';

export function useExperiences(
  ids: string[],
): UseAsyncCollectionResT<ExperienceT> {
  return useAsyncCollection(
    ids,
    'experiences',
    getExperience,
    { maxage: time.HOUR_MS },
  );
}
